<div class="reporting-group-administration no-field-space">

  <sc-master-detail [selection]="[selected]" [data]="listEntries" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <ng-container *ngIf="workingCopyDetails">
      <div class="form" [formGroup]="detailsFormGroup">
        <div class="group-details">
          <div class="scrollable">
            <div class="form-box" *ngIf="workingCopyDetails">



              <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
                [labelDictionaryKey]="'tmc-yard.entity.reporting-group.name'" [required]="true" [maxlength]="4000"
                (dictionaryChanged)="onDictionaryChanged()">
              </sc-dictionary-field>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <mat-form-field appearance="fill">
                <mat-label>{{'sortIndex' | translate: ['tmc-yard.entity.reporting-group.sort-index',
                  translationService.language]}}</mat-label>
                <input formControlName="sortIndex" name="sortIndex" matInput matIntegerInput type="number"
                  [required]="true" />
              </mat-form-field>

              <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

              <sc-sub-title>
                {{'coloring' |
                translate:['tmc-yard.entity.reporting-group.coloring.title',
                translationService.language]}}</sc-sub-title>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex >

                <div>{{'level 1' | translate: ['tmc-yard.entity.reporting-group.coloring.level-1',
                  translationService.language]}}</div>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'color' | translate: ['tmc-yard.entity.reporting-group.color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="color1" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                  </app-color-picker>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'background color' | translate: ['tmc-yard.entity.reporting-group.background-color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="backgroundColor1" (colorSelected)="colorPickerChanged()" name="background-color"
                    [required]="false">
                  </app-color-picker>
                </mat-form-field>

              </sc-flex>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex >

                <div>{{'level 2' | translate: ['tmc-yard.entity.reporting-group.coloring.level-2',
                  translationService.language]}}</div>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'color' | translate: ['tmc-yard.entity.reporting-group.color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="color2" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                  </app-color-picker>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'background color' | translate: ['tmc-yard.entity.reporting-group.background-color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="backgroundColor2" (colorSelected)="colorPickerChanged()" name="background-color" [required]="false">
                  </app-color-picker>
                </mat-form-field>

              </sc-flex>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex >

                <div>{{'level 3' | translate: ['tmc-yard.entity.reporting-group.coloring.level-3',
                  translationService.language]}}</div>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'color' | translate: ['tmc-yard.entity.reporting-group.color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="color3" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                  </app-color-picker>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <mat-form-field appearance="fill">
                  <mat-label>{{'background color' | translate: ['tmc-yard.entity.reporting-group.background-color',
                    translationService.language]}}</mat-label>
                  <app-color-picker formControlName="backgroundColor3" (colorSelected)="colorPickerChanged()" name="background-color" [required]="false">
                  </app-color-picker>
                </mat-form-field>

              </sc-flex>


              <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

              <sc-sub-title>{{'assigned stations' |
                translate:['tmc-yard.widgets.reporting-group-administration.assigned-stations.title',
                translationService.language]}}</sc-sub-title>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <div class="station-assignment" style="grid-column: 1; grid-row: 6;">
                <div class="stations-list" style="grid-column: 1; grid-row:  2;">
                  <div class="station" *ngFor="let station of stations">
                    {{station.name}}
                    <i (click)="removeStation(station)" class="cursor-pointer fa-light fa-times"></i>
                  </div>
                </div>
                <div class="delete-button-wrapper" style="grid-column: 2; grid-row:  2;">
                  <i class="cursor-pointer fa-light fa-plus" (click)="addStation()"></i>
                </div>
              </div>

              <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

              <sc-sub-title>
                {{'assigned station sets' |
                translate:['tmc-yard.widgets.reporting-group-administration.assigned-station-sets.title',
                translationService.language]}}</sc-sub-title>

              <div class="station-assignment" style="grid-column: 1; grid-row: 8;">
                <div class="stations-list" style="grid-column: 1; grid-row:  2;">
                  <div class="station" *ngFor="let stationSet of stationSets">
                    {{stationSet.name}}
                    <i (click)="removeStationSet(stationSet)" class="cursor-pointer fa-light fa-times"></i>
                  </div>
                </div>
                <div class="delete-button-wrapper" style="grid-column: 2; grid-row:  2;">
                  <i class="cursor-pointer fa-light fa-plus" (click)="addStationSet()"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
        [disabled]="!cancelEnabled">{{'cancel'
        | translate: ['tmc-yard.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button type="button" class="config-changed-button" (click)="save()"
        [disabled]="!saveEnabled">{{'save'
        |
        translate:
        ['tmc-yard.action.save',
        translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>
</div>
